import { createReducer } from 'redux-create-reducer';
import { selectSiteAction, unselectSiteAction } from '../actions/sites';
import { isExistingSiteUpdateAction } from '../actions/form';

const initialState = {
  customerId: undefined,
  siteId: undefined,
  isFetching: false,
  isExistingSite: true,
  errors: [],
};

import { selectCustomerAction } from '../actions/customers';

const ERRORS = 'errors';

export const formReducer = createReducer(initialState, {
  [isExistingSiteUpdateAction](state, action) {
    return {
      ...state,
      isExistingSite: action.payload,
    };
  },
  [selectCustomerAction](state, action) {
    return {
      ...state,
      customerId: parseInt(action.payload, 10),
      siteId: undefined,
    };
  },
  [selectSiteAction](state, action) {
    return {
      ...state,
      siteId: parseInt(action.payload.id, 10),
    };
  },
  [unselectSiteAction](state, action) {
    return {
      ...state,
      siteId: undefined,
    };
  },
  [ERRORS](state, action) {
    return {
      ...state,
      errors: action.payload,
    };
  },
});

export default formReducer;

export const getErrors = state => state.form.errors;
export const getCustomerId = state => state.form.customerId;
export const getSelectedSite = state => state.form.siteId;
export const getIsExistingSite = state => state.form.isExistingSite;



// WEBPACK FOOTER //
// ./src/modules/saas/aast/common/modals/case-transfer/reducers/form.js